import script from "./ClientMatterSearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClientMatterSearch.vue?vue&type=script&setup=true&lang=ts"

import "./ClientMatterSearch.vue?vue&type=style&index=0&id=9481e6c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9481e6c8"]])

export default __exports__